import { render, staticRenderFns } from "./debugbox.vue?vue&type=template&id=26329384&scoped=true&lang=pug"
import script from "./debugbox.vue?vue&type=script&lang=js"
export * from "./debugbox.vue?vue&type=script&lang=js"
import style0 from "./debugbox.vue?vue&type=style&index=0&id=26329384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26329384",
  null
  
)

export default component.exports